<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { isImageSrc } from '@/utils'

const props = defineProps<{ imageSrc?: string, isChat?: boolean }>()

const imgSrc = ref<string>()

onMounted(() => {
  if (props.imageSrc && isImageSrc(props.imageSrc))
    imgSrc.value = props.imageSrc
})
</script>

<template>
  <div v-if="props.isChat" class="chat-avatar">
    <div shape="squircle" class="avatar-image">
      <img v-if="imgSrc" :src="imgSrc" alt="Profile image">
      <img v-else src="../../assets/avatar.png" alt="Profile image">
    </div>
  </div>
  <div v-else class="avatar-wrapper">
    <div class="avatar-container">
      <div class="avatar">
        <div shape="squircle" class="avatar-image avatar-box">
          <img v-if="!imgSrc" src="../../assets/avatar.png" alt="Profile image">
          <img v-else :src="imgSrc" alt="Profile image">
        </div>
      </div>
    </div>
  </div>
</template>
